import React, { useEffect, useId, useRef } from "react";
import mermaid from "mermaid";

mermaid.initialize({ startOnLoad: false, securityLevel: "strict", theme: "base", themeVariables: { primaryColor: "#17171a", primaryTextColor: "#eceae6", primaryBorderColor: "#d99a3d", lineColor: "#d99a3d", secondaryColor: "#0e0e10", tertiaryColor: "#0a0a0b", fontFamily: "IBM Plex Sans, sans-serif", edgeLabelBackground: "#0e0e10", mainBkg: "#17171a", nodeBorder: "#d99a3d", nodeBkg: "#17171a", nodeTextColor: "#eceae6", clusterBkg: "#0e0e10", clusterBorder: "rgba(255,255,255,.16)" }, flowchart: { htmlLabels: true, curve: "basis", useMaxWidth: true, nodeSpacing: 30, rankSpacing: 42 } });

export default function MermaidDiagram({ chart, ariaLabel }) {
  const id = useId().replace(/:/g, "");
  const targetRef = useRef(null);
  useEffect(() => {
    let cancelled = false;
    async function renderDiagram() {
      if (!targetRef.current || !chart) return;
      try {
        const result = await mermaid.render(`case-study-${id}`, chart);
        if (cancelled || !targetRef.current) return;
        targetRef.current.innerHTML = result.svg;
        const svg = targetRef.current.querySelector("svg");
        if (svg) {
          svg.setAttribute("role", "img");
          svg.setAttribute("aria-label", ariaLabel || "Architecture diagram");
          svg.removeAttribute("width");
          svg.style.width = "auto";
          svg.style.maxWidth = "100%";
          svg.style.height = "auto";
          svg.style.display = "block";
          svg.style.margin = "0 auto";
          const viewBox = svg.viewBox.baseVal;
          if (viewBox.height > viewBox.width) svg.style.width = `${Math.min(viewBox.width, 360)}px`;
        }
      } catch (error) {
        if (!cancelled && targetRef.current) targetRef.current.innerHTML = `<pre class="diagram-fallback">${chart.replace(/</g, "&lt;")}</pre>`;
      }
    }
    renderDiagram();
    return () => { cancelled = true; };
  }, [ariaLabel, chart, id]);
  return <div className="case-study-diagram" ref={targetRef} aria-label={ariaLabel || "Architecture diagram"} />;
}
